import { playerState, gameState } from "../state/stateManagers.js";

export default function reset(k) {
  k.add([
    k.text("🔁 Resetting...", { size: 36 }),
    k.pos(k.center()),
    k.anchor("center"),
  ]);

  // 🧹 Clear all localStorage flags set by gameState
  for (let key in localStorage) {
    if (key.startsWith("flag-")) {
      localStorage.removeItem(key);
    }
  }

  // 🧹 Reset player state flags
  playerState.setHasPickedUpAntiqueKey(false);
  playerState.setHasPickedUpManga(false);
  playerState.setHasPickedUpOriyoki(false);
  playerState.setHasOriyoki(false);
  playerState.setHasPickedUpSword(false);
  playerState.setHasPickedUpStrawberries(false);

  // 🕒 Delay briefly then go to main menu or world
  k.wait(1, () => {
    k.go("world");
  });
}
